import { render, staticRenderFns } from "./mainTop.vue?vue&type=template&id=7836279c&scoped=true&"
import script from "./mainTop.vue?vue&type=script&lang=js&"
export * from "./mainTop.vue?vue&type=script&lang=js&"
import style0 from "./mainTop.vue?vue&type=style&index=0&id=7836279c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836279c",
  null
  
)

export default component.exports